@if (!isNullOrUndefined(progress) && progress >= 0) {
  <app-circle-progress
    #circleProgress
    class="circle-progress"
    [progress]="progress"
    [progressColor]="progressColor"
    [tabIcon]="svgIconPath"
  ></app-circle-progress>
}

<div class="flex flex-row items-center option-container relative">
  @if (svgIconPath && isNullOrUndefined(progress)) {
    <svg-icon class="w-4 h-4 mr-1" [class.opacity-100]="selected" [src]="svgIconPath"></svg-icon>
  }

  <span class="text-wrapper inline-flex items-center">
    <span class="text">
      <ng-content></ng-content>
    </span>

    @if (shouldDisplayCount) {
      &nbsp;
      <span class="count">{{ '(' + count + ')' }}</span>
    }
  </span>

  @if (notificationDot) {
    <span class="notification-dot rounded bg-pink-50 w-1.5 h-1.5 absolute top-0.5 right-0"></span>
  }
</div>

@if (selected) {
  <div class="selection-mark absolute bottom-0 h-0.5 bg-navy-90 w-full rounded-md"></div>
}
